module.exports = __webpack_public_path__ + "0b4bdec3e8096465b87a40cac95fb8ea.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/caja prestamos.png
// module id = 591
// module chunks = 0